// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"193":"5524ebb0109996dc","201":"38cacde5b94fe392","334":"669a261380374549","608":"088659e042208b5c","721":"18c960cebe7bf2ff","765":"6ea9a47eaab3f809"}[chunkId] + ".js";
};